module.exports = __webpack_public_path__ + "static/img/Oliver-Dean.185cf06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Oliver-Dean.jpg
// module id = sIEB
// module chunks = 0